<template>
<div class="library-book-chapter-wrap">
  <div class="container main-1">
    <section class="thumb">当前位置：<nuxt-link to="/library">图书馆</nuxt-link> &gt; <nuxt-link :to="`/library/${$route.params.book}`">{{ book.bookName }}</nuxt-link> &gt; {{ content.sectionName }}</section>
    <div class="clearfix">
      <section class="book left">
        <div class="head">
          <h2>{{ content.sectionName }}</h2>
          <div class="book-info clearfix">
            <p>书名：{{ book.bookName }}</p>
            <p>作者： {{ book.author }}</p>
            <p>出版时间： {{ book.createAt.slice(0, 10) }}</p>
            <p>出版社： {{ book.press }}</p>
          </div>
        </div>
        <div class="body" v-html="content.content"></div>
      </section>
      <section class="fixed left">
        <nuxt-link tag="div" :to="`/library/${$route.params.book}`"><i class="iconfont icon-mulu"></i></nuxt-link>
        <div @click="link(0)"><i class="iconfont icon-left"></i></div>
        <div @click="link(1)"><i class="iconfont icon-right"></i></div>
        <div><a href="#__nuxt"><i class="iconfont icon-huidaodingbu"></i></a></div>
      </section>
    </div>
    
  </div>
</div>
</template>

<script>
export default {
  scrollToTop: true,
  async asyncData ({ params, $axios }) {
    let book = await $axios._get('/Books/Detail', { bookid: +params.book })
    let chapters = book.section.map(_ => _.id)
    let content = await $axios._get('/Books/ChapterContent', { bookid: +params.book, sectionid: +params.chapter })
    return {
      book,
      content,
      chapters
    }
  },
  methods: {
    link (flag) {
      let index = this.chapters.indexOf(+this.$route.params.chapter)
      flag ? index++ : index--
      if (this.chapters[index]) {
        this.$router.push(`/library/${this.$route.params.book + '/' + this.chapters[index]}`)
      }
    }
  }
}
</script>

<style lang="less">
.library-book-chapter-wrap {
  background-color: #e5e4db;
  .container {
    padding: 40px 0 60px; position: relative;
    .thumb {
      font-size: 14px; color: #666666;
    }
    .book {
      width: 1000px; background-color: #f6f4ec; padding: 50px; margin-top: 22px;
      box-shadow: 0px 0px 4px #ccc;
      .head {
        border-bottom: 1px solid #e3e1d9;
        .book-info {
          font-size: 14px; color: #999; padding: 20px 0;
          p {
            float: left;
            &:not(:first-child) {
              margin-left: 15px;
            }
          }
        }
      }
      .body {
        margin-top: 20px; line-height: 2;
      }
    }
    .fixed {
      position: sticky; top: 210px; margin-left: 30px;
      div {
        width: 60px; height: 60px; background-color: #f6f4ec; text-align: center; cursor: pointer; position: relative; box-shadow: 0px 0px 4px #ccc;
        &:not(:first-child) {
          margin-top: 10px;
        }
        .iconfont {
          font-size: 36px; display: inline-block; margin-top: 11px;
        }
      }
    }
  }
  
}
</style>
